<template>
  <b-container fluid class="layout-wide py-5">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="font-weight-bold"><span class="text-primary">공급자</span> 관리</h2>
      <div class="text-right mt-3">
        <b-button v-if="isEdit" variant="warning" @click="updateProvider" class="mr-2">수정 완료</b-button>
        <b-button v-else variant="primary" @click="saveProvider">신규 등록</b-button>
        <b-button v-if="isEdit" variant="light" @click="resetForm">취소</b-button>
      </div>
    </div>

    <b-card class="border-0 shadow-sm mb-4 rounded-lg">
      <b-row>
        <b-col md="4">
          <b-form-group label="상호명">
            <b-form-input v-model="form.companyName" class="jinro-input"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="대체 상호명">
            <b-form-input v-model="form.replacementCompanyName" class="jinro-input" placeholder="필요시 입력"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="등록번호">
            <b-form-input v-model="form.regNo" class="jinro-input" placeholder="000-00-00000"></b-form-input>
          </b-form-group>
        </b-col>

        <b-col md="4">
          <b-form-group label="대표자 성명">
            <b-form-input v-model="form.ownerName" class="jinro-input"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="전화번호">
            <b-form-input v-model="form.tel" class="jinro-input" placeholder="010-0000-0000"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="팩스번호">
            <b-form-input v-model="form.fax" class="jinro-input" placeholder="02-000-0000"></b-form-input>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="주소">
            <b-form-input v-model="form.address" class="jinro-input"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="업태">
            <b-form-input v-model="form.bizType" class="jinro-input"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group label="종목">
            <b-form-input v-model="form.bizItem" class="jinro-input"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <b-table :items="providers" :fields="fields" head-variant="light" class="bg-white shadow-sm rounded">
      <template #cell(updatedAt)="data">
        <span class="bg-white">
          {{ formatDateTime(data.value) }}
        </span>
      </template>
      <template #cell(actions)="data">
        <b-button size="sm" variant="outline-primary" @click="editMode(data.item)" class="mr-1">수정</b-button>
        <b-button size="sm" variant="outline-danger" @click="deleteProvider(data.item.id)">삭제</b-button>
      </template>
    </b-table>
  </b-container>
</template>

<script>

export default {
  data() {
    return {
      form: {
        id: null,
        userId: null,
        companyName: '',
        replacementCompanyName: '', // 추가
        regNo: '',
        ownerName: '',
        tel: '', // 추가
        fax: '', // 추가
        address: '',
        bizType: '',
        bizItem: ''
      },
      providers: [],
      isEdit: false,
      fields: [{key: 'companyName', label: '상호', thClass: 'text-center', tdClass: 'text-center align-middle'},
        {key: 'regNo', label: '등록번호', thClass: 'text-center', tdClass: 'text-center align-middle'},
        {key:'updatedAt', label:'최근 수정일', thClass: 'text-center', tdClass: 'text-center align-middle'},
        {key: 'actions', label: '관리', thClass: 'text-center', tdClass: 'text-center align-middle'}]
    }
  },
  created() {
    this.loadProviders();
  },
  methods: {
    // 날짜 변환 함수
    formatDateTime(dateStr) {
      if (!dateStr) return '-';
      // T를 공백으로 바꾸고, 초 단위(:00)가 필요 없다면 .substring(0, 16) 자릅니다.
      // 예: 2025-12-23 14:07:00
      return dateStr.replace('T', ' ').substring(0, 19);
    },
    editMode(item) {
      this.isEdit = true;
      this.form = {...item}; // 선택한 데이터 폼에 복사
    },
    resetForm() {
      this.isEdit = false;
      this.form = {
        id: null,
        companyName: '',
        replacementCompanyName: '',
        regNo: '',
        ownerName: '',
        tel: '',
        fax: '',
        address: '',
        bizType: '',
        bizItem: ''
      };
    },
    async updateProvider() {
      try {
        this.form.userId = localStorage.getItem('userId');
        const res = await this.$axios.post('/api/provider/save', this.form);
        if (res.status === 200) {
          alert('수정되었습니다.');
          this.loadProviders();
          this.resetForm();
        }
      } catch (err) {
        console.error(err);
      }
    },
    async loadProviders() {
      try {
        const res = await this.$axios.get('/api/providers', {
          params: {
            userId: localStorage.getItem('userId')
          }
        })
        this.providers = res.data.data.providers;
      } catch (err) {
        console.error(err);
      }
    },
    async saveProvider() {
      try {
        this.form.userId = localStorage.getItem('userId');
        const res = await this.$axios.post('/api/provider/save', this.form);
        if (res.status === 200) {
          alert('등록되었습니다.');
          this.loadProviders();
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
}
</script>
